import SortShutter from './component'

export default SortShutter
